'use strict';

require('../../style/index.less');

require('./index.less');

require('../../checkbox/style');

require('../../button/style');

require('../../input/style');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.8.1@antd/lib/transfer/style/index.js
// module id = 978
// module chunks = 0